<template>
  <div class='institutional-qnr-intro-view is-flex-center gap-2 view p-6'>
      <div class='page-width mr-6 '>
        <img  :src="context.advisor_logo">
        <div class="pl-2">
        <h1 class='title is-3 is-extra-bold'>Responsible Investing Questionnaire</h1>
        <div class='is-flex-col gap-1 is-size-5'>
          <p>Hi <span class='weight-bold'>{{context.name}}</span>,</p>
          <p>You have been sent this questionnaire by <span class='weight-bold'>{{context.advisor_name}}</span> ({{context.advisor_email}}).</p>
          <p class='is-size-4 is-extra-bold'>Why take the questionnaire? </p>
          <div class='is-flex'>
            <p>This questionnaire will help you translate <a>{{context.client_group_name}}</a>'s mission into a Responsible Investment policy. Your responses will help determine the <strong>Motivations</strong>, <strong>Strategies</strong>, and <strong>Values</strong> that will be reflected in the policy.
            <br><br>As part of this process, you will have the opportunity to share any thoughts or questions you have about Responsible Investing.
            <br><br>Your responses will be aggregated with the rest of your team to build consensus and identify potential misalignment.</p>
          </div>
        </div>
        </div>
      </div>
      <div >
        <QnrIntroGetStarted :context="context"/>
      </div>
  </div>
</template>


<script>
import QnrIntroGetStarted from '../../components/institutional_questionnaire/QnrIntroGetStarted.vue';

export default {
  name: 'institutional-qnr-intro-view',
  components: { QnrIntroGetStarted },
  props: [ 'context'],
  data() {
    return { };
  },
  beforeCreate() {},
  async created() {
  },
  mounted() {},
  updated() {},
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  methods: {},
};
</script>


<style scoped>
.logo {
  border: 1px dashed black;
}
img {
  max-height: 200px;
}
</style>
